export const BRANCHES = [
  {
    name: "Branch1",
  },
  {
    name: "Branch2",
  },
  {
    name: "Branch3",
  },
];

export const COURSES = [
  {
    name: "Course1",
  },
  {
    name: "Course2",
  },
  {
    name: "Course3",
  },
];

export const COURSE_TIMES = [
  {
    name: "08:00 - 10:00",
  },
  {
    name: "10:00 - 12:00",
  },
  {
    name: "13:00 - 15:00",
  },
  {
    name: "16:00 - 18:00",
  },
];

export const FORM_STATE = {
  name: { value: "", error: false, required: true },
  surname: { value: "", error: false },
  phoneNumber: { value: "+998", error: false, required: true },
  branch: { value: "", id: "", error: false },
  course: { value: "", id: "", error: false },
  courseTime: { value: "", error: false },
  comment: { value: "", error: false },
};
